import { buildProps } from '@zoryn/utils'

export interface DashboardProps {
  /** Max content width, e.g. `1280px` */
  maxWidth?: string
}

export interface DashboardSectionProps {
  title?: string
  hint?: string
  count?: number | string
}

export interface DashboardCardProps {
  label: string
  favorite?: boolean
  disabled?: boolean
  tone?: number
  enterDelay?: number
  showFavorite?: boolean
  enterText?: string
}

export interface DashboardEmptyProps {
  title?: string
  description?: string
}

export const dashboardProps = buildProps({
  maxWidth: {
    type: String,
    default: '1280px',
  },
} as const)

export const dashboardSectionProps = buildProps({
  title: {
    type: String,
    default: '',
  },
  hint: {
    type: String,
    default: '',
  },
  count: {
    type: [Number, String],
    default: undefined,
  },
} as const)

export const dashboardCardProps = buildProps({
  label: {
    type: String,
    required: true,
  },
  favorite: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  tone: {
    type: Number,
    default: 0,
  },
  enterDelay: {
    type: Number,
    default: 0,
  },
  showFavorite: {
    type: Boolean,
    default: true,
  },
  enterText: {
    type: String,
    default: '进入',
  },
} as const)

export const dashboardEmptyProps = buildProps({
  title: {
    type: String,
    default: '暂无常用模块',
  },
  description: {
    type: String,
    default: '在功能卡片右上角点星标即可收藏',
  },
} as const)
